const states = {
  message: '', // 最后一条消息id
};
export default states;
